import apiService from "../common/commonApi";

export const leaveHistory = {};

leaveHistory.getListHistory = async (param) => {
    return apiService.Get("getLeaveHistory", param);
};
